export enum Level {
  TRACE = 'TRACE',
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  OFF = 'OFF'
}

const LOG_LEVEL_PRIORITY: Record<string, number> = {
  [Level.TRACE]: 0,
  [Level.DEBUG]: 1,
  [Level.INFO]: 2,
  [Level.WARN]: 3,
  [Level.ERROR]: 4,
  [Level.OFF]: 5
};

export class LevelHelper {
  static getPriority(level: Level): number {
    return LOG_LEVEL_PRIORITY[level];
  }
}

export enum ColorType {
  BLUE = 'blue',
  TEAL = 'teal',
  GRAY = 'gray',
  RED = 'red'
}

export class LogRecord {

  timestamp: string;

  constructor(public level: Level,
              public logger: string,
              public message: string,
              public data: unknown,
              public tags: Array<string> = []) {
    this.timestamp = new Date().toISOString();
  }
}
